import { api } from "../config/api";
import { post } from "../api";

export interface ForceLogoutUserPayload {
  logout_user: string;
  user_id?: string | number;
  business_id: string | null;
  device_token: string | null;
  session_id: string | null;
}

export interface ForceLogoutUserResponse {
  success?: boolean;
  errors?: string;
  message?: string;
  data?: { success?: boolean; errors?: string; message?: string };
}

function isForceLogoutResponseSuccessful(res: ForceLogoutUserResponse | undefined): boolean {
  if (!res || typeof res !== "object") return true;
  if (res.success === false) return false;
  const nested = res.data;
  if (nested && typeof nested === "object" && nested.success === false) return false;
  return true;
}

function getForceLogoutErrorMessage(res: ForceLogoutUserResponse | undefined): string {
  if (!res || typeof res !== "object") return "Force logout failed.";
  const nested = res.data;
  const msg =
    (typeof res.errors === "string" && res.errors.trim()) ||
    (typeof res.message === "string" && res.message.trim()) ||
    (nested && typeof nested.errors === "string" && nested.errors.trim()) ||
    (nested && typeof nested.message === "string" && nested.message.trim());
  return msg || "Force logout failed.";
}

function forceLogoutUser(payload: ForceLogoutUserPayload): Promise<ForceLogoutUserResponse> {
  return post<ForceLogoutUserResponse>(api.FORCE_LOGOUT_USER, payload);
}

export const dashboardService = {
  forceLogoutUser,
  isForceLogoutResponseSuccessful,
  getForceLogoutErrorMessage,
};
